import { render } from "./poisonpage.vue?vue&type=template&id=28d2f666"
import script from "./poisonpage.vue?vue&type=script&lang=js"
export * from "./poisonpage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__